module.exports = __webpack_public_path__ + "static/media/qualitas-off-app-provider-icon.cf7e444b.svg";